import { connect } from 'react-redux';
import { DocumentHead } from './DocumentHead';
import { RematchContext } from 'models/rematchStore';

const mapState = ({ appData: { selectedScreen, selectedParkData } }) => ({
    selectedScreen,
    selectedParkData,
});

export const DocumentHeadContainer = connect(mapState, undefined, undefined, { context: RematchContext })(DocumentHead);
